import React from "react";

function NoContent({ message }) {
  return <div className="no-content">{message}</div>;
}

export default NoContent;
